import React from "react";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { TextBoxEditor } from "../../../../react-core/Html/TextBoxEditor";
import { ContentFilter } from "../Resource/Content";

interface IInsuredFundValidateProps {
    filter: any;
    handleFilterChange: (changes) => void;
    onSearch: VoidFunction;
    displayName: string;
}

interface IInsuredFundValidateState {}

export class InsuredFundValidate extends FormComponent<IInsuredFundValidateProps, IInsuredFundValidateState> {
    constructor(props: IInsuredFundValidateProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        return <>{this.renderFilters()}</>;
    }

    private renderFilters(): JSX.Element {
        const { FundCode } = this.props.filter;
        const { handleFilterChange, displayName } = this.props;
        return (
            <>
                <div className="row narrow-gutter">
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            value={FundCode}
                            placeholder={ContentFilter.fundCode}
                            onChange={(v) => handleFilterChange({ FundCode: v })}
                        />
                    </div>
                    <div className="col-auto col-bottom">
                        <div className="form-group">
                            <div className="controls">
                                <button
                                    className="btn secondary"
                                    onClick={() => {
                                        if (this.isValid()) {
                                            this.props.onSearch();
                                        }
                                    }}
                                >
                                    {ContentFilter.validate}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-auto">
                    <span>{displayName}</span>
                </div>
            </>
        );
    }
}
